var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex items-start py-3 px-2.5" }, [
    _c(
      "div",
      { staticClass: "flex flex-col", class: _vm.avatarPosition },
      [
        _c("CircleWithInitials", {
          attrs: {
            large: "customH",
            avatar: this.data.sender.avatar,
            title: _vm.senderName,
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "flex flex-col customMargin" }, [
      _c("div", { staticClass: "flex flex-row widthClass gap-2" }, [
        _c(
          "span",
          { staticClass: "text-base font-medium text-primary-black" },
          [_vm._v(" " + _vm._s(_vm.senderName) + " ")]
        ),
        _c(
          "span",
          { staticClass: "dateTime flex", class: _vm.messageDatePosition },
          [_vm._v(" " + _vm._s(_vm.messageDate) + " ")]
        ),
      ]),
      _vm.data.content
        ? _c(
            "div",
            { staticClass: "flex flex-col" },
            _vm._l(_vm.messageContent, function (content) {
              return _c("span", { key: content }, [
                _vm._v(" " + _vm._s(content) + " "),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm.data.attachment
        ? _c(
            "div",
            {
              staticClass:
                "cursor-pointer flex items-center Message-hover transition duration-300",
              on: {
                click: function ($event) {
                  return _vm.handleDownload(_vm.data.attachment)
                },
              },
            },
            [
              _vm.uploadingShown
                ? _c("div", [
                    _c("div", [
                      _c("span", {
                        staticClass: "text-xl mdi mdi-file-document-outline",
                      }),
                      _c(
                        "span",
                        {
                          staticClass:
                            "ml-2 text-badgeBlue text-normal text-base",
                        },
                        [_vm._v(_vm._s(_vm.filename))]
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex items-center" },
                      [
                        _c("Spinner", {
                          staticClass: "mr-2",
                          attrs: { size: "sm" },
                        }),
                        _c("span", { staticClass: "text-sm text-gray-600" }, [
                          _vm._v("Uploading..."),
                        ]),
                      ],
                      1
                    ),
                  ])
                : _c(
                    "div",
                    { staticClass: "flex mt-1 flex-row gap-1 imageContainer" },
                    [
                      _c("span", {}, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "13",
                              height: "18",
                              viewBox: "0 0 13 18",
                              fill: "none",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: { "clip-path": "url(#clip0_58_37954)" },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M0 2.625C0 1.45293 0.95293 0.5 2.125 0.5H7.4375V4.75C7.4375 5.3377 7.9123 5.8125 8.5 5.8125H12.75V15.375C12.75 16.5471 11.7971 17.5 10.625 17.5H2.125C0.95293 17.5 0 16.5471 0 15.375V2.625ZM12.75 4.75H8.5V0.5L12.75 4.75Z",
                                    fill: "#1A7BEE",
                                  },
                                }),
                              ]
                            ),
                            _c("defs", [
                              _c(
                                "clipPath",
                                { attrs: { id: "clip0_58_37954" } },
                                [
                                  _c("rect", {
                                    attrs: {
                                      width: "13",
                                      height: "17",
                                      fill: "white",
                                      transform: "translate(0 0.5)",
                                    },
                                  }),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _c("span", { staticClass: "ml-2 text-badgeBlue" }, [
                        _vm._v(_vm._s(_vm.filename)),
                      ]),
                    ]
                  ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }